import React from "react";
import { MASCOT_URL } from "../constants/content";

/**
 * Chaotic butt-face mascot used across the app.
 * No rounded corners — brutalist frame.
 */
export const Mascot = ({ size = 96, className = "", crown = false, shake = false, ring = "#FFEA00" }) => {
  return (
    <div
      className={`relative inline-block ${shake ? "vibrate" : ""} ${className}`}
      style={{ width: size, height: size }}
      data-testid="mascot"
    >
      {crown && (
        <div
          className="absolute -top-7 left-1/2 -translate-x-1/2 font-mono text-[12px] px-2 py-0.5 bg-[#FFEA00] text-black brutal-border"
          style={{ borderWidth: 3 }}
        >
          #1 CRINGE
        </div>
      )}
      <div
        className="relative overflow-hidden"
        style={{
          width: size,
          height: size,
          border: `4px solid ${ring}`,
          boxShadow: `6px 6px 0 0 #FF003C`,
          background: "#000",
        }}
      >
        <img
          src={MASCOT_URL}
          alt="Jack Doherty butt-face mascot"
          className="w-full h-full object-cover"
          draggable={false}
        />
      </div>
    </div>
  );
};
